// TOUR-11 — Fulfillment inventory + new piece entry (lot manager path).

import type { FireflyTourArtifact } from "../tourTypes";

export const FULFILLMENT_INVENTORY_TOUR_ID = "tour-fulfillment-inventory";

export const FULFILLMENT_INVENTORY_TOUR: FireflyTourArtifact = {
  id: FULFILLMENT_INVENTORY_TOUR_ID,
  version: 1,
  defaultIntent: "teaching",
  intents: [
    "fulfillment tour",
    "fulfillment inventory tour",
    "add inventory on the lot",
    "receive a unit",
    "lot inventory tour",
    "how do i add a unit to inventory",
    "new inventory entry tour",
  ],
  bucketRelevance: ["fulfillment"],
  requiredRoles: ["sales"],
  requiredCapabilities: ["hasSalesFloor"],
  steps: [
    {
      id: "nav-inventory",
      target: {
        mode: "fulfillmentInventory",
        anchorId: "mode-nav-fulfillmentInventory",
        scrollIntoView: true,
      },
      deferModeNavigation: true,
      skipWhenCurrentMode: "fulfillmentInventory",
      copy: {
        title: "Open Inventory",
        body: "See every unit on your lot here — cash purchases, repos, and intake status at a glance. Tap Inventory in the Fulfillment bucket (sidebar or bottom bar).",
      },
      waitForClick: true,
    },
    {
      id: "inventory-list",
      target: {
        mode: "fulfillmentInventory",
        anchorId: "ff-inventory-list",
        scrollIntoView: true,
      },
      copy: {
        title: "Lot inventory list",
        body: "Each row shows the unit label, origin, and intake badge when a form is pending or in review. Refresh pulls the latest holder-org units.",
      },
      advanceOn: "next_button",
    },
    {
      id: "nav-entry",
      target: {
        mode: "fulfillmentEntry",
        anchorId: "mode-nav-fulfillmentEntry",
        scrollIntoView: true,
      },
      deferModeNavigation: true,
      skipWhenCurrentMode: "fulfillmentEntry",
      copy: {
        title: "New inventory entry",
        body: "Add a single cash purchase or repo unit, or bulk-import from CSV. Tap New inventory in the Fulfillment bucket.",
      },
      waitForClick: true,
    },
    {
      id: "entry-form",
      target: { mode: "fulfillmentEntry", anchorId: "ff-entry-form", scrollIntoView: true },
      copy: {
        title: "Single-piece entry",
        body: "Pick origin, optional plant, and an intake template if you want a form queued automatically. Notes help the lot team identify the piece.",
      },
      advanceOn: "next_button",
    },
    {
      id: "entry-create",
      target: { mode: "fulfillmentEntry", anchorId: "ff-entry-create", scrollIntoView: true },
      copy: {
        title: "Create unit",
        body: "Create unit issues a sentinel serial (CASH-#### or REPO-####) and optionally materializes an intake form from the template you selected.",
      },
      destructive: true,
    },
    {
      id: "ask-firefly",
      target: { mode: "fulfillmentEntry", anchorId: "ask-firefly", scrollIntoView: true },
      copy: {
        title: "Ask Firefly anytime",
        body: "Inspection intake and form tiers live in the Intake modes. Ask Firefly anytime for capture or opportunity tours from Sales modes.",
      },
      advanceOn: "next_button",
    },
  ],
};
